import React, { useEffect, useState } from "react";
import MyPayHeader from "../../../components/MyPayHeader";
import GrossProration from "../../../components/GrossProration";
import PaySlips from "../../../components/PaySlips";
import PayPackage from "../../../components/PayPackage";
import api from "../../../api/axios";
import { useLocation, useParams } from "react-router-dom";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { decrypt } from "../../../utils/crypto";

function MyPay() {
  let { employee_id } = useParams();
  employee_id = decrypt(employee_id);
  const location = useLocation();
  const { employeeName = "" } = location.state || {};
  const [activeHeader, setActiveHeader] = useState("paySlips");
  const [salary, setSalary] = useState("");
  const [salaryConfig, setSalaryConfig] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { company } = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    api
      .get(
        `employees/companies/${company.company_id}/employees/${employee_id}/salary-breakdown`,
        {
          params: { month: "2024-11" },
        }
      )
      .then((response) => {
        console.log("response config ", response.data.config);
        setSalaryConfig(response?.data?.config);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, []);

  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content container-fluid position-relative">
          <Breadcrumbs
            maintitle={`${employeeName} My pay`}
            title="Dashboard"
            subtitle="My pay"
          />
          <MyPayHeader
            activeHeader={activeHeader}
            setActiveHeader={setActiveHeader}
            setSalary={setSalary}
          />
          {activeHeader === "payPackage" && (
            <PayPackage
              setSalary={setSalary}
              setActiveHeader={setActiveHeader}
              employeeId={employee_id}
            />
          )}
          {activeHeader === "grossProration" && (
            <GrossProration
              salary={salary}
              salaryConfig={salaryConfig}
              employeeId={employee_id}
            />
          )}
          {activeHeader === "paySlips" && (
            <PaySlips salaryConfig={salaryConfig} employeeId={employee_id} />
          )}
        </div>
      </div>
    </div>
  );
}

export default MyPay;
